export const MAP_TYPE = "MAP_TYPE";
export const VIDEO_TYPE = "VIDEO_TYPE";
export const COLOR_TYPE = "COLOR_TYPE";
export const IMAGE_TYPE = "IMAGE_TYPE";
export const PROCESSING_TYPE = "PROCESSING_TYPE";
export const GIPHY_TYPE = "GIPHY_TYPE";